import { makeStyles, Theme, } from '@material-ui/core/styles';
import { orangered, } from 'styles/abstract/variables';

export const makeFilterCheckboxStyles = makeStyles((theme: Theme) => ({
    root: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(0),

        '&:hover': {
            background: 'none',
        },

        '&$checked': {
            color: orangered,
        },
    },

    checked: {},
}), { index: 1, });

export const makeCheckboxLabelStyles = makeStyles((theme: Theme) => ({
    root: {
        ...theme.typography.h6,
        fontWeight: 600,
        fontSize: '1.125rem',
        marginBottom: theme.spacing(1),
    },
}), { index: 1, });

export const makeProductsContainerFilterStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: 0,
        marginBottom: theme.spacing(2),
    },
}), { index: 1, });
